import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

const RiskBadge = ({ score, label }) => {
  const { t } = useTranslation();
  const value = Number(score || 0);
  const color = value >= 75 ? "error" : value >= 55 ? "warning" : "success";
  return <Chip size="small" color={color} variant="outlined" label={label || t("platform.risk.badge", { value })} sx={{ fontWeight: 600 }} />;
};

export default RiskBadge;
